// extracted by css-extract-rspack-plugin
export default {"cls1":"Configuration-cls1_byn","cls2":"Configuration-cls2_cSK Configuration-cls1_byn"};